// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"styles_sliderWrapper__977Y_","slider":"styles_slider__suJl9","fieldContainer":"styles_fieldContainer__AX1Jn"};